<div class="alert alert-info d-flex align-items-start gap-3 mb-3" *ngIf="showBanner" role="alert">
  <i class="fas fa-info-circle fa-2x"></i>
  <div class="flex-fill">
    <h6 class="alert-heading mb-2" i18n>Connect eVisitor for Croatian Compliance</h6>
    <p class="mb-2" i18n>
      We noticed you have rentals in Croatia. Connect the eVisitor Compliance API to easily register guests with
      Croatian authorities and manage tourist tax reporting.
    </p>
    <div class="d-flex gap-2">
      <a class="btn btn-sm btn-info" routerLink="/compliance/options" (click)="onConnect()" i18n>
        <i class="far fa-link mr-1"></i> Connect eVisitor
      </a>
    </div>
  </div>
  <button type="button" class="close" aria-label="Close" i18n-aria-label (click)="onDismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
